<template>
  <section class="peak">
    <div class="container">
      <a-typography-title :level="1">
        <span>全方位、全流程的</span>
        <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />
        <span>流量高峰应对方案</span>
      </a-typography-title>
      <div v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)"
           class="box_line">
        <PlanPeakLine ref="line" />
      </div>
      <a-row :gutter="[40,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :lg="12" :xl="8">
          <div ref="item" class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              <span>{{ item.title }}</span>
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.title_sub }}
            </a-typography-paragraph>
            <div class="content">
              <template v-for="v in item.content">
                <p>{{ v.title }}</p>
                <span>{{ v.text }}</span>
              </template>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalFormCollection','demo')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import PlanPeakLine from '@template/page/planStable/component/planPeakLine.vue';

export default {
  name: 'plan_peak',
  components: {
    PlanPeakLine
  },
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '高峰前',
            title_sub: '减少时间成本，提高评估有效性',
            content: [
              {
                title: '全链路承载量评估',
                text: '通过快速压测，迅速掌握集群承载能力。'
              },
              {
                title: '新业务快速迭代',
                text: '老业务保持在线，分钟级部署新业务，避免重启影响现网业务。'
              },
              {
                title: '保障预案有效性评估',
                text: '准确评估某个业务降级带来的稳定性收益。'
              }
            ]
          },
          {
            title: '高峰期',
            title_sub: '快速响应，支撑超预期峰值',
            content: [
              {
                title: '服务集群快速扩容',
                text: '资源申请周期由10天缩短到1天，节省开销。'
              },
              {
                title: '平稳支撑超预期高峰',
                text: '基于精准的业务指标监控，快速获取云资源、部署业务。'
              },
              {
                title: '一键式云资源抢购',
                text: '当云资源紧张时，提供资源快速抢购功能。'
              }
            ]
          },
          {
            title: '高峰后',
            title_sub: '自动恢复资源状态，提供优化建议',
            content: [
              {
                title: '流量下降时算力自动缩容',
                text: '算力资源随访问量下降而自动缩容至平时状态。'
              },
              {
                title: '算力成本分析及建议',
                text: '针对业务进行资源利用率和算力成本分析，提供进一步优化建议。'
              }
            ]
          }
        ]
      }
    };
  },
  mounted(): void {
    this.listenMouseOver();
  },
  methods: {
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener('mouseover', () => {
          this.$refs.line?.setCircle(i + 1);
        }, false)
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planStable/';

.peak {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  position: relative;
  z-index: 1;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_line {
  position: relative;
  z-index: 0;
  height: 220px;
}

.ant-row {
  margin: 0;
}

.item {
  @wh: 30px;
  @style: transform @time, box-shadow @time;
  overflow: hidden;
  position: relative;
  padding: 20px;
  background: @color_white;
  border: 2px solid @color_14;
  border-radius: 8px;
  .transition(@style);
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      h5.ant-typography {
        &::before {
          background-position-x: -(-1 + @i)*@wh;
        }
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &:hover {
    .transform(translateY(-5px));
    .shadow(0 15px 25px fade(#6E778B, 20));
  }
  
  h5.ant-typography {
    position: relative;
    margin: 0;
    .font(center, @wh, @color_12, @text_big, true);
    
    &::before {
      content: '';
      display: inline-block;
      width: @wh;
      height: @wh;
      margin: 0 10px 0 0;
      .bg('@{image}peak_icon.png', @wh*3, @wh);
      vertical-align: top;
    }
    
    span {
      display: inline-block;
      vertical-align: top;
    }
  }
  
  div.ant-typography {
    position: relative;
    margin: @margin_mo 0 0;
    .font(center, @text+@line, @color_12, @text);
    
    &::before {
      content: '';
      display: block;
      .position(bottom, -10px);
      width: 70px;
      height: 3px;
      margin: 0 auto;
      background: @color_6;
      border-radius: 2px 2px 0 0;
    }
  }
  
  .content {
    min-height: 250px;
    margin: @margin 0 0;
    
    p {
      position: relative;
      padding-left: 15px;
      margin: 15px 0 0;
      .font(left, @text, @color_12, @text, true);
      
      &:first-child {
        margin: 0;
      }
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 6px, auto, auto, 0);
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: @color_6;
      }
    }
    
    span {
      display: block;
      min-height: 42px;
      padding-left: 15px;
      margin: @margin_mo 0 0;
      .font(left, @text+5px, @color_13, @text);
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .peak {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .box_line {
    height: 150px;
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    h5.ant-typography {
      .font(center, 30px, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      .font(center, @text_mo+@line_mo, @color_12, @text_mo);
    }
    
    .content {
      min-height: auto;
      
      p {
        .font(left, @text_mo, @color_12, @text_mo, true);
      }
      
      span {
        min-height: auto;
      }
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>